<template>
  <header class="header-main">
    <div class="header-main__wrapper main-container">
      <div class="header-main__menu">
        <MenuLogo />
        <div>
          <nav v-if="menuRole(role)" class="header-main__nav">
            <router-link v-for="item in menuRole(role)" :to="item.url" class="header-main__nav-item">
              <p class="header-main__nav-name">{{item.name}}</p>
            </router-link>
            <MenuSettings v-if="settingsRole(role)" :items="settingsRole(role)" />
          </nav>
        </div>
        <MenuUserTitle :profile-info="profileInfo?.full_name?.value" :name="nameRole(role)" @click="showPersonalDataWindow = true"/>
      </div>
    </div>

    <ModalWindow v-if="showPersonalDataWindow">
      <PersonalData
        :profileInfo="profileInfo"
        @close="showPersonalDataWindow = false"
        @openLogout="openLogoutModal"
        @openChangePasswordModal="openChangePasswordModal"
      />
    </ModalWindow>

    <ModalWindow v-if="showLogoutWindow">
      <LogOut @close="showLogoutWindow = false" @logout="logout" />
    </ModalWindow>

    <ModalWindow v-if="showChangePassword">
      <ChangePassword
        :errorPasswordText="errorPasswordText"
        @close="(showChangePassword = false), (errorPasswordText = '')"
        @change="postChangePassword"
      />
    </ModalWindow>
  </header>
</template>

<script setup>
import { onMounted, ref, onUnmounted } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import apiProfile from "@/api/profile";
import ModalWindow from "@/components/ModalWindow/index.vue";
import PersonalData from "@/components/ModalWindow/ModalBodyes/PersonalData";
import LogOut from "@/components/ModalWindow/ModalBodyes/LogOut";
import ChangePassword from "@/components/ModalWindow/ModalBodyes/ChangePassword";
import {
  APPROVING_PERSON,
  HR,
  ADMIN,
  ADMIN_SETTINGS,
  SECURITY_SERVICE,
  SUPER_ADMIN
} from "@/constants";
import MenuUserTitle from "@/components/Menu/user-title.vue";
import MenuSettings from "@/components/Menu/menu-settings.vue";
import MenuLogo from "@/components/Menu/logo.vue";

const menuRole = (role) => {
  let menuAll = {
    "SUPER_ADMIN": SUPER_ADMIN,
    "ADMIN": ADMIN,
    "HR": HR,
    "APPROVING_PERSON": APPROVING_PERSON,
    "SECURITY_SERVICE": SECURITY_SERVICE,
  }
  return menuAll[role]
}

const settingsRole = (role) => {
  let menuAll = {
    "SUPER_ADMIN": false,
    "ADMIN": ADMIN_SETTINGS,
    "HR": false,
    "APPROVING_PERSON": false,
    "SECURITY_SERVICE": false,
  }
  return menuAll[role]
}

const nameRole = (role) => {
  let menuAll = {
    "SUPER_ADMIN": "Технический администратор",
    "ADMIN": "Администратор",
    "HR": "HR-менеджер",
    "APPROVING_PERSON": "Согласовант",
    "SECURITY_SERVICE": "СБ",
  }
  return menuAll[role]
}

const store = useStore();
const router = useRouter();

const role = store.getters["auth/role"];
const showPersonalDataWindow = ref(false);
const showLogoutWindow = ref(false);
const showChangePassword = ref(false);
const logout = async () => {
  await apiProfile.getLogout();
  await store.dispatch("auth/logout");
  setTimeout(() => {
    showLogoutWindow.value = false;
    router.push("/authorization");
  }, 400);
};

const openLogoutModal = () => {
  showPersonalDataWindow.value = false;
  showLogoutWindow.value = true;
};

const openChangePasswordModal = () => {
  showPersonalDataWindow.value = false;
  showChangePassword.value = true;
};

const profileInfo = ref({});
const getProfile = async () => {
  const response = await apiProfile.getProfile();
  profileInfo.value = response;
  await store.dispatch("auth/setProfile", response);
};
const errorPasswordText = ref("");
const postChangePassword = async (body) => {
  errorPasswordText.value = "";
  try {
    const response = await apiProfile.postChangePassword(body);
    await store.dispatch("auth/logout");
    setTimeout(() => {
      showChangePassword.value = false;
      router.push("/authorization");
    }, 400);
  } catch (error) {
    console.log(error);
    if (error?.response?.data?.errors?.current_password.length) {
      errorPasswordText.value = error.response.data.errors.current_password[0];
    } else {
      await store.dispatch("auth/logout");
      setTimeout(() => {
        showChangePassword.value = false;
        router.push("/authorization");
      }, 400);
    }
  } finally {
  }
};

onMounted(() => {
  getProfile();
});
</script>

<style scoped lang="scss">
.header-main {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 56px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #E4E7EE;
  background-color: #f4f5f7;
  user-select: none;
  z-index: 99;

  &__menu {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__nav {
    display: flex;
    align-items: center;
    flex: 1 1 auto;
    justify-content: flex-end;
    margin-left: 20px;
  }

  &__nav-item {
    padding: 8px 12px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    text-decoration: none;

    &_settings{
      cursor: pointer;
    }
    &_settings-active{
      cursor: pointer;
      position: relative;
    & > .header-main__nav-item-icon {
      opacity: 1;
      path,
      rect {
        stroke: #fff;
        color: #fff;
      }
    }

    & .header-main__nav-item-chevron {
      transform: rotate(0deg);
    }

    & > .header-main__nav-name {
      opacity: 1;
    }
    }

    &:not(:first-child) {
      //margin-left: 12px;
    }
  }

  &__nav-item-chevron{
    transform: rotate(180deg);
  }

  &__nav-item-icon {
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0.5;
  }

  &__nav-name {
    margin-left: 8px;
    color: #000;
    font-size: 14px;
    font-weight: 400;
    opacity: 0.5;
  }

  .router-link-active {
    position: relative;

    & > .header-main__nav-item-icon {
      opacity: 1;
      path,
      rect {
        stroke: #000;
        color: #000;
      }
    }

    & > .header-main__nav-name {
      //opacity: 1;
    }
  }

  &__profile-btn {
    max-width: 160px;
    margin-left: auto;
    cursor: pointer;
  }


  &__profile-btn-type {
    width: 100px;
    color: #000;
    margin-top: 4px;
    font-size: 12px;
    font-weight: 400;
    opacity: 0.5;
    line-height: normal;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__profile-chat-btn {
    width: 133px;
    margin-left: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #000;
    cursor: pointer;

    p {
      margin-left: 8px;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;

      span {
        margin-left: 4px;
      }
    }

    img {
      margin-left: 8px;
    }
  }
}
</style>
